import { Component, OnInit, Input } from '@angular/core';
import { HorariosService } from 'src/app/services/horarios.service';
import { Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AuthService } from 'src/app/services/auth.service';
import { StatusAgendamentoService } from 'src/app/services/status-agendamento.service';
import { ServerUrlService } from 'src/app/services/server-url.service';
import { ProcedimentosService } from 'src/app/services/procedimentos.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { ConveniosService } from 'src/app/services/convenios.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { PagamentosService } from 'src/app/services/pagamentos.service';

interface Response extends Array<any> { }

@Component({
  selector: 'app-resumo-client',
  templateUrl: './resumo-client.component.html',
  styleUrls: ['./resumo-client.component.scss']
})
export class ResumoClientComponent implements OnInit {
  @Input() stepper: any;
  @Input() sessionData: any;
  smallScreen: boolean;
  infoPagamento: any = {};
  temPagamento: boolean = false;

  paidUsingPix: boolean = false
  loadingConfirm: boolean = false

  constructor(
    private horariosService: HorariosService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private auth: AuthService,
    private statusAgendamentoService: StatusAgendamentoService,
    private serverUrlService: ServerUrlService,
    private procedimentoService: ProcedimentosService,
    private usuariosService: UsuariosService,
    private conveniosService: ConveniosService,
    private snackBar: SnackbarService,
    private paymentService: PagamentosService
  ) {
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });
  }

  ngOnInit() {
  }

  onVoltarClick() {
    this.stepper.previous();
  }

  validaDados() {
    const { userData, horarioSel, selecaoObj } = this.sessionData;

    if(!userData){
      const userData = sessionStorage.getItem("userData")
      this.sessionData.userData = JSON.parse(userData)
    }

    if (this.sessionData.userData && horarioSel && selecaoObj) { return true; }
    return false;
  }

  async onConfirmarClick() {
    this.sessionData.test = {};
    this.sessionData.infoPagamento = this.infoPagamento;
    this.sessionData.selecaoObj.validadeCarteirinha = this.conveniosService.validadeCarteirinha

    this.usuariosService.atualizarUsuario(this.sessionData).subscribe((resp) => {
      this.horariosService.confirmaAgendamento({...this.sessionData, infoPagamento: this.infoPagamento})
        .subscribe(async (retorno: any) => {
          const { agendaTipo, id } = retorno
          if (agendaTipo === 'cs') {
            const blobs = this.procedimentoService.procedimentoAnexos
            const req1 = await fetch(`https://cms-backend.otimusclinic.com/variables/host/${this.serverUrlService.getName()}`, {
              method: 'POST'
            })
            const variables = await req1.json()

            const req2 = await fetch(`${this.serverUrlService.getUrl()}/integracao/pega-token-otimus`, {
              method: 'POST'
            })
            const nometoken = await req2.json()

            if (
              this.conveniosService &&
              this.conveniosService.convenioParametros &&
              this.conveniosService.convenioParametros.parametroObrigarCarteirinhaAnexo) {
              const carteirinhaBlob = this.conveniosService.anexoCarteirinha
              await fetch(`${variables.find(el => el.chave === 'Otimus_URL').valor}/api/v1/agendamento/${id}/anexos`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  descricao: 'anexo de carteirinha do agendamento web',
                  fileBase64: await this.blobToBase64(carteirinhaBlob),
                  tipo: carteirinhaBlob.type.split('/')[1],
                  sistema: nometoken.nome,
                  token: nometoken.token
                })
              })
            }

            if (blobs) {
              for (const blob of blobs) {
                const req3 = await fetch(`${variables.find(el => el.chave === 'Otimus_URL').valor}/api/v1/agendamento/${id}/anexos`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    descricao: 'anexo do agendamento web',
                    fileBase64: await this.blobToBase64(blob),
                    tipo: blob.type.split('/')[1],
                    sistema: nometoken.nome,
                    token: nometoken.token
                  })
                })
                const res = await req3.json()
              }

            }
          }
          if (agendaTipo === 'am' || agendaTipo === 'ag') {
            const req1 = await fetch(`https://cms-backend.otimusclinic.com/variables/host/${this.serverUrlService.getName()}`, {
              method: 'POST'
            })
            const variables = await req1.json()

            const req2 = await fetch(`${this.serverUrlService.getUrl()}/integracao/pega-token-otimus`, {
              method: 'POST'
            })
            const nometoken = await req2.json()

            if (this.conveniosService &&
              this.conveniosService.convenioParametros &&
              this.conveniosService.convenioParametros.parametroObrigarCarteirinhaAnexo) {
              const carteirinhaBlob = this.conveniosService.anexoCarteirinha
              await fetch(`${variables.find(el => el.chave === 'Otimus_URL').valor}/api/v1/agendamento/${id}/anexos`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  descricao: 'anexo de carteirinha do agendamento web',
                  fileBase64: await this.blobToBase64(carteirinhaBlob),
                  tipo: carteirinhaBlob.type.split('/')[1],
                  sistema: nometoken.nome,
                  token: nometoken.token
                })
              })
            }
          }
          if(!this.temPagamento) {
            this.router.navigate(['/' + this.serverUrlService.getName() +'/client/meus-agendamentos'], {
              state: {
                mandarParaAgendamento: true,
                agendamentoId: id,
                agendaTipo
              }
            });
          }
        },
          (err) => {
            console.error('err', err);
            window.alert('Autenticação de usuário expirada, favor logar novamente.');
            // sessionStorage.removeItem('userData');
            // this.auth.logOutUser();
            // this.stepper.previous();
          }
        );
    })
  };

  checkRuleAndConfirm() {
    this.loadingConfirm = true
    const {userData, selecaoObj, horarioSel} = this.sessionData

    const data = {
      convenio_id: selecaoObj.convenio.integracao_id,
      agenda_id: horarioSel.hora.agendaid,
      agenda_tipo: horarioSel.hora.tipo,
      data: horarioSel.hora.dataconsulta.split(' ')[0],
      procedimento_id: selecaoObj.procedimento.procedimento_integracao_id,
      modalidade: selecaoObj.procedimento.servico_modalidade,
      paciente_id:  userData.integracao_id,
      plano_descricao: selecaoObj.plano.descricao || null,
    }

    this.horariosService.getRule(data).subscribe({ next: (resp: any) => {
      const {regra_violada} = resp.data

      if(!regra_violada) {
        this.onConfirmarClick()
        return
      }

      const treatedReason = this.getViolatedRuleReason(regra_violada)

      if(regra_violada.acao === 'nao permitir') {
        this.snackBar.openSnackBar(treatedReason, '')
        return
      } else if (regra_violada.acao === 'alertar') {
        this.snackBar.openSnackBar(treatedReason, '')
        this.onConfirmarClick()
      }
      
      this.loadingConfirm = false
    }, error: (err) => {
      if(err.status === 404){
        this.onConfirmarClick()
        return
      }

      this.loadingConfirm = false
    }})
  }

  getViolatedRuleReason(violatedRule): string {
    const {regra, min_idade, max_idade, quantidade} = violatedRule
    let treatedReason = ''

    if(['retorno', 'retorno_medico'].includes(regra)) {
      treatedReason = `O tempo máximo de ${quantidade} dias para retorno expirou.`
    }
    if(regra === 'idade') {
      treatedReason = `Você não tem a idade necessária para este agendamento. A idade `

      if(min_idade) treatedReason += `mínima é de ${min_idade} anos`
      if(min_idade && max_idade) treatedReason += ' e a idade '
      if(max_idade) treatedReason += ` máxima é de ${max_idade} anos`
    } 
    return treatedReason
  }

  onResumo = this.statusAgendamentoService.stepStatusChange.subscribe(value => {
    if (value.selectedStep && value.selectedStep.label == "stepResumo") {
      this.infoPagamento = this.statusAgendamentoService.infoPagamento;
      const paidUsingPix = this.statusAgendamentoService.paidWithPix
      if(paidUsingPix) {
        this.temPagamento = true;
        sessionStorage.removeItem('pixPayment')
      } else if(!(JSON.stringify(this.infoPagamento) === '{}')) {
        this.temPagamento = true;
        this.onConfirmarClick();
        sessionStorage.removeItem('pixPayment')
      }
    }
  });

  onFinalizar = () => {
    sessionStorage.removeItem('pixPayment')
    this.statusAgendamentoService.infoPagamento = undefined
    this.router.navigate(['/' + this.serverUrlService.getName() +'/client/meus-agendamentos']);
  };

  abrePagamento = () => {
    if(this.infoPagamento.invoiceUrl) {
      let win = window.open(this.infoPagamento.invoiceUrl, '_blank');
      win.focus();
      return
    }
    if(!this.infoPagamento.id) return
    this.paymentService.getTransactionById(this.infoPagamento.id).subscribe((resp: any) => {
      if(!resp.transactionReceiptUrl) return
      let win = window.open(resp.transactionReceiptUrl, '_blank');
      win.focus();
    })
  }

  blobToBase64(blob: Blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }
}
